{
  "greeting": "Sunt asistentul virtual RO Auto Market, un program AI. Pentru o persoană reală, scrie-ne pe WhatsApp.",
  "header_title": "Asistent Virtual",
  "header_subtitle": "RoAutoMarket - Online acum",
  "input_placeholder": "Întreabă despre vehicule...",
  "typing": "Scriu răspuns...",
  "error": "Ne pare rău, a apărut o eroare. Te rog încearcă din nou.",
  "button_aria": "Asistent Virtual",
  "suggestions": {
    "search": "🔍 Caută vehicule",
    "deal": "💎 Oferta zilei",
    "compare": "⚖️ Compară vehicule",
    "finance": "💰 Calculează credit"
  }
}